export default{
  
}


// WEBPACK FOOTER //
// ./src/store/modules/resumes/state.js